import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  CustomCard,
  ImportXmlFiles,
  Loading,
  PageHeader,
  TextBtn,
} from '../../../../../../components'
import { Panel } from 'primereact/panel'
import { showMessageBox } from '../../../../../../store/actions/system.actions'
import EstoqueHttp from '../../../../../../services/api/https/estoque/Estoque.http'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../../assets/js/styles'
import { DataTable } from 'primereact/datatable'
import { errorHandler } from '../../../../../../services/util/error.service'

const ShowMode = {
  MESSAGE: 'MESSAGE',
  LOADING: 'LOADING',
  CARDS: 'CARDS',
  PRODUTOS_NAO_CADASTRADOS: 'PRODUTOS_NAO_CADASTRADOS',
}

const Loading_Types = {
  FETCH_CARD_INFO: 'FETCH_CARD_INFO',
  IMPORT: 'IMPORT',
  NONE: 'NONE',
}
const INIT_STATE = {
  showMode: ShowMode.MESSAGE,
  loading: Loading_Types.NONE,
  errorMessage: null,
  qteSkus: 0,
  qteVolumes: 0,
  produtosNaoCadastrados: [],
}

function ImportacaoExpedicaoXml({ history, dispatch, selectedTp }) {
  // Vars
  const { selectedMovimentacao } = history.location.state

  // Hooks
  const [state, setState] = useState({ ...INIT_STATE })

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (selectedMovimentacao && selectedMovimentacao.id) {
      setState(prevState => ({
        ...prevState,
        loading: Loading_Types.FETCH_CARD_INFO,
        showMode: ShowMode.LOADING,
      }))
    }
  }, [selectedMovimentacao.id])

  useEffect(() => {
    if (state.loading === Loading_Types.FETCH_CARD_INFO) {
      fetchCardsInfo(selectedTp, selectedMovimentacao.id, (error, info) => {
        if (error) {
          setState(prevState => ({
            ...prevState,
            loading: Loading_Types.NONE,
            showMode: ShowMode.MESSAGE,
            errorMessage: errorHandler(error),
          }))
        } else {
          const { qteSkus, qteVolumes } = info
          if (qteSkus > 0) {
            setState(prevState => ({
              ...prevState,
              loading: Loading_Types.NONE,
              errorMessage: null,
              showMode: ShowMode.CARDS,
              qteSkus,
              qteVolumes,
            }))
          } else {
            setState(prevState => ({
              ...prevState,
              loading: Loading_Types.NONE,
              errorMessage: null,
              showMode: ShowMode.MESSAGE,
            }))
          }
        }
      })
    }
  }, [state.loading])

  const onXmlImportationSuccess = async data => {
    try {
      if (selectedTp === 0) {
        setState({ ...state, errorMessage: 'Selecione a Operação' })
      } else {
        const { id: movimentacao_expedicao_id, file_type_id } = selectedMovimentacao
        const { qteSkus, qteVolumes } = await EstoqueHttp.importExpedicaoXml(
          selectedTp,
          movimentacao_expedicao_id,
          file_type_id,
          data,
        )
        setState(prevState => ({
          ...prevState,
          loading: Loading_Types.NONE,
          errorMessage: null,
          showMode: ShowMode.CARDS,
          qteSkus,
          qteVolumes,
        }))
      }
    } catch (error) {
      const { productsNotSaved } = error
      if (productsNotSaved) {
        setState({
          ...state,
          showMode: ShowMode.PRODUTOS_NAO_CADASTRADOS,
          errorMessage: 'Existe(m) produto(s) NÃO cadastrado(s)',
          produtosNaoCadastrados: productsNotSaved,
        })
      } else {
        setState({ ...state, showMode: ShowMode.MESSAGE, errorMessage: errorHandler(error) })
      }
    }
  }

  // Helpers

  // Render
  return (
    <>
      <PageHeader>
        Importação&nbsp;<strong>XML</strong>&nbsp;-&nbsp;Movimentação Expedição
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel
          header={
            <ImportacaoPanelHeader
              onSuccess={onXmlImportationSuccess}
              onError={error => setState({ ...state, errorMessage: error })}
              onVoltar={history.goBack}
              isLoading={state.loading !== Loading_Types.NONE}
            />
          }
        >
          {state.showMode === ShowMode.MESSAGE ? (
            <div style={{ textAlign: 'center', color: '#c4c4c4' }}>
              Para realizar a importação, clique no botão Importar
            </div>
          ) : null}
          {state.showMode === ShowMode.CARDS ? (
            <CardsResultadoImportacaoExpedicao
              qteSkus={state.qteSkus}
              qteVolumes={state.qteVolumes}
            />
          ) : null}
          {state.showMode === ShowMode.PRODUTOS_NAO_CADASTRADOS ? (
            <ProdutosNaoCadastrados
              onRowClick={() => {}}
              produtosNaoCadastrados={state.produtosNaoCadastrados}
            />
          ) : null}
          {state.showMode === ShowMode.LOADING ? <Loading /> : null}
        </Panel>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ImportacaoExpedicaoXml))

// ---------------------
// Local Components
// ---------------------

function ImportacaoPanelHeader({ isLoading, onError, onSuccess, onVoltar }) {
  // Render
  return (
    <div className="p-grid">
      <div className="p-col-3">
        <div style={{ display: 'inline-block', position: 'relative', width: 80, height: 20 }}>
          <div
            className="text-center"
            style={{
              visibility: !isLoading ? 'visible' : 'hidden',
              position: 'absolute',
            }}
          >
            <ImportXmlFiles onError={onError} onSuccess={onSuccess} />
          </div>
          <div
            className="text-center"
            style={{
              visibility: isLoading ? 'visible' : 'hidden',
              position: 'absolute',
            }}
          >
            <Loading />
          </div>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <TextBtn onClick={onVoltar}>Voltar</TextBtn>
        </div>
      </div>
    </div>
  )
}

function ProdutosNaoCadastrados({ onRowClick, produtosNaoCadastrados }) {
  return (
    <DataTable
      selectionMode="single"
      onSelectionChange={e => onRowClick(e.value)}
      paginator={true}
      rows={10}
      value={produtosNaoCadastrados}
    >
      <Column field="code" header="Código" style={tableCellCentered()} />
      <Column field="name" header="Produto" />
    </DataTable>
  )
}

function CardsResultadoImportacaoExpedicao({ qteVolumes, qteSkus }) {
  // Vars
  const items = [
    { title: 'Qte de Volumes', value: qteVolumes },
    { title: 'Qte Skus', value: qteSkus },
  ]

  const valueStyle = {
    fontSize: '1.2rem',
    color: '#14B0BF',
    fontWeight: 600,
  }
  return (
    <div className="p-grid">
      {items.map(i => (
        <div className="p-col-3" key={i.title}>
          <CustomCard valueStyle={valueStyle} title={i.title}>
            {i.value.toLocaleString()}
          </CustomCard>
        </div>
      ))}
    </div>
  )
}

async function fetchCardsInfo(tpId, movimentacaoExpedicaoId, cb) {
  try {
    const info = await EstoqueHttp.getExpedicaoInfo(tpId, movimentacaoExpedicaoId)
    cb(null, info)
  } catch (error) {
    cb(error, null)
  }
}
